module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-header', {
    attrs: {
      "fixed": "",
      "title": "固定在顶部"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header-main"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Header")]), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "标题过长会隐藏后面的内容啊哈哈哈哈"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "多个按钮"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('mt-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "左侧仅文字"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    slot: "left"
  }, [_c('mt-button', [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "右侧仅文字"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    slot: "right"
  }, [_c('mt-button', [_vm._v("分享")])], 1)], 1), _vm._v(" "), _c('mt-header', {
    attrs: {
      "title": "仅图标"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  })], 1), _vm._v(" "), _c('mt-button', {
    attrs: {
      "icon": "more"
    },
    slot: "right"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02fefac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/header.vue
// module id = 262
// module chunks = 0